import { isNativeTourModelEnabled } from '../../nativeTourModel';

export function isSlidingScaleEnabled(): boolean {
  return isNativeTourModelEnabled();
}

export const SLIDING_SCALE_TAB_TYPE = 'sliding-scale';

export const SLIDING_SCALE_TAB_TITLE = 'Pricing and inventory';
